import { z } from "zod";

/**
 * The kinds of notification a person chooses for, as the API names them. The reminder email names
 * the same kinds, so the word a person picks here is the word the email uses.
 */
export const NotificationKindSchema = z.enum([
  "Messages",
  "Invitations",
  "Proposals",
  "Agreements",
  "Marketplace",
  "Connections",
  "Other",
]);

/**
 * How one kind reaches the person. There is no "email only": the only email is the reminder about
 * unread notifications, and it links to the notification center.
 */
export const NotificationDeliverySchema = z.enum(["InAppAndEmail", "InAppOnly"]);

export const NotificationKindDeliverySchema = z.object({
  kind: NotificationKindSchema,
  delivery: NotificationDeliverySchema,
});

export const NotificationDeliveryPreferencesSchema = z.object({
  emailDigestEnabled: z.boolean(),
  kinds: z.array(NotificationKindDeliverySchema),
});

export type NotificationKind = z.infer<typeof NotificationKindSchema>;
export type NotificationDelivery = z.infer<typeof NotificationDeliverySchema>;
export type NotificationKindDelivery = z.infer<typeof NotificationKindDeliverySchema>;
export type NotificationDeliveryPreferencesJSON = z.infer<typeof NotificationDeliveryPreferencesSchema>;
